export * from './gedenkportal-internal.component';
export * from './gedenkportal-internal.service';
